export const getters = {
	threads: state => state.threads,
	thread: state => id => state.threads.filter((thread) => { return thread.id === id })[0],
	threadOfClient: state => id => {
		return state.threads.filter((thread) => { return (thread.client) ? parseInt(thread.client.id) === parseInt(id) : false })
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Chat/getters.js